import styled from "styled-components";
import { Col, Divider, Row } from "antd";
import { GhostButtonComponent } from "../../../../../../CommonComponents/commonStyles";

export const GrantsPaymentContent = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  padding-right: 50px;
  padding-left: 50px;
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.textColor};
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : "10px")}
    @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    padding-right: 0px;
    padding-left: 10px;
    letter-spacing: 0.5px;
    margin-bottom: ${props => (props ? props.mobmb : "10px")};
  }
  && span {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  }
`;

export const AddressContainer = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  margin-left: 150px;
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.thead};
  margin-bottom: ${props => props.theme.spacing.margins.margin50};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    margin-left: 50px;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-bottom: ${props => props.theme.spacing.margins.YBetThreeQtr};
  }
  @media only screen and (min-width: 320px) and (max-width: 375px) {
    margin-left: ${props => props.theme.spacing.margins.mdMargin}
  }
`;

export const AdvisorContainer = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  max-width: 200px;
  margin-left: 150px;
  margin-bottom: 20px;
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.thead};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    margin-left: 30px;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-bottom: ${props => (props ? props.mobmb : "10px")};
  }
  float: left;
  && p {
    margin-bottom: 0px;
  }
`;

export const Img = styled.img`
  width: 143px;
  height: 60px;
  @media only screen and (max-width: 576px) {
    width: 120px;
    height: 48px;
  }
`;

export const DataContainer = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.secondary};
  margin-right: 50px;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.thead};
  padding-left: 150px;
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : "10px")}
    @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    padding-left: 10px;
    margin-bottom: ${props => (props ? props.mobmb : "10px")};
  }
`;

export const DataHeading = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  padding-right: 50px;
  padding-left: 50px;
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.thead};
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : "10px")}
    @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    padding-right: 0px;
    padding-left: 10px;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-bottom: ${props => (props ? props.mobmb : "10px")};
  }
`;

export const FirstColumn = styled(Col)`
  padding-left: 50px;
  @media only screen and (max-width: 990px) {
    padding-left: 10px;
  }
`;

export const SecondColumn = styled(Col)`
  padding-left: 50px;
  @media only screen and (max-width: 990px) {
    padding-left: 10px;
  }
`;

export const ModalButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
  padding-bottom: 50px;
`;

export const CancelButton = styled(GhostButtonComponent)`
  width: 9.375rem;
  @media (min-width: 320px) and (max-width: 990px) {
    width: 9.375rem;
  }
`;

export const HorizontalDivider = styled(Divider)`
  border-bottom: solid 1px #bfbfbf;
  &.noMargin {
    margin: 0px;
  }
  &.blurify {
    margin-bottom: 3rem;
    opacity: 0.4;
  }
  @media only screen and (max-width: 990px) {
    margin: 0rem;
    margin-bottom: 1rem;
  }
`;

export const InfoContent = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.thead};
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : "10px")}
    @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-bottom: ${props => (props ? props.mobmb : "10px")};
  }
`;

export const GrantContent = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.thead};
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : "10px")}
    @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-bottom: ${props => (props ? props.mobmb : "10px")};
  }
`;

export const GrantContentItalic = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-style: italic;
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.thead};
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : "10px")}
    @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-bottom: ${props => (props ? props.mobmb : "10px")};
  }
`;

export const DataContainerLetter = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  margin-right: 50px;
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.thead};
  padding-left: 150px;
  margin-bottom: 10px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    padding-left: 10px;
    margin-bottom: ${props => (props ? props.mobmb : "10px")};
  }
  > span {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  }
`;
export const GrantsPaymentContentPurposeBased = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  padding-right: 50px;
  padding-left: 150px;
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.thead};
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : "10px")}
    @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    padding-right: 0px;
    padding-left: 10px;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-bottom: ${props => (props ? props.mobmb : "10px")};
  }
`;
export const GrantsPaymentContentCC = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  adding-right: 50px;
  padding-left: 50px;
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.thead};
  margin-bottom: 0px @media only screen and (min-width: 320px) and
    (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.tableFont};
    padding-right: 0px;
    padding-left: 10px;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-bottom: ${props => (props ? props.mobmb : "10px")};
  }
`;
export const AdvisorWrapper = styled.div`
  overflow: hidden;
`;

export const AdditionalCommentSpan = styled.span`
  white-space: pre-wrap;
  font-family: ${props => props.theme.fontFamily.helveticaNeue} !important;
`;

export const LetterMainRow = styled(Row)`
  margin-top: ${props => props.theme.spacing.margins.quaternary}
`;
